// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2FaE4","info":"UpdateTermsInfo_info__5B6L-"};